import { render } from "./PharmacyDashboardPage.vue?vue&type=template&id=403423a9"
import script from "./PharmacyDashboardPage.vue?vue&type=script&lang=js"
export * from "./PharmacyDashboardPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__